// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"118":"b9e3bbbd","388":"815f3f36","412":"996591ee","432":"1509238b","452":"6798ab53","549":"26b4b389","558":"73c73490","702":"5f513a0e","761":"a8f1e25b","770":"77c5101c","792":"b94e4761","821":"a6c8973a","833":"c608d289","991":"6f1260a2"}[chunkId] + ".js";
};